import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardSalesOrderReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardSalesOrder,
  endpoint: "order",
  reportKey: "orders",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Sales Order  Report provides detailed information about a rep's sales orders",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardSalesOrderReportConfig;
